import { render, staticRenderFns } from "./TelecomRecBlock.vue?vue&type=template&id=13e7a79b"
import script from "./TelecomRecBlock.vue?vue&type=script&lang=js"
export * from "./TelecomRecBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports